export const toCamelCase = (obj, excludeKeys = []) => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => toCamelCase(item, excludeKeys));
    }

    const newObj = {};
    for (const key of Object.keys(obj)) {
        if (excludeKeys.includes(key)) {
            newObj[key] = obj[key];
            continue;
        }

        const newKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
        newObj[newKey] = toCamelCase(obj[key], excludeKeys);
    }
    return newObj;
};

export const toSnakeCase = (obj, excludeKeys = []) => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => toSnakeCase(item, excludeKeys));
    }

    const newObj = {};
    for (const key of Object.keys(obj)) {
        if (excludeKeys.includes(key)) {
            newObj[key] = obj[key];
            continue;
        }

        const newKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        newObj[newKey] = toSnakeCase(obj[key], excludeKeys);
    }
    return newObj;
};
